import { render } from "./PatientQueueScannerModal.vue?vue&type=template&id=0c08968f&scoped=true&ts=true"
import script from "./PatientQueueScannerModal.vue?vue&type=script&lang=ts"
export * from "./PatientQueueScannerModal.vue?vue&type=script&lang=ts"

import "./PatientQueueScannerModal.vue?vue&type=style&index=0&id=0c08968f&scoped=true&lang=css"

import exportComponent from "/home/rdimicheleb/Repos/AMII/apps/app-paciente/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c08968f"]])

export default __exports__